import { makeStyles } from '@material-ui/core';
import { backgroundImg } from './slide4.module';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundImage: `url(${backgroundImg})`,
    width: '100%',
    height: '880px',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'contain',
    backgroundSize: 'cover',
    borderTop: '123px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: '10%',
    /* transform: 'rotate(-180deg)' */
  },
  comingSoon: {
    fontFamily: 'Montserrat',
    fontSize: '62px',
    fontWeight: '400',
    color: '#06E89F',
    lineHeight: '64px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '24px',
      lineHeight: '32px',
    },
  },
  text: {
    width: '80%',
    color: '#FFF',
    fontFamily: 'Montserrat',
    fontWeight: '400',
    fontSize: '62px',
    lineHeight: '64px',
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      fontSize: '24px',
      lineHeight: '32px',
      textAlign: 'center',
    },
  },
}));

export default useStyles;
